import { c as _c } from "react/compiler-runtime";
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { Media } from '@/models/media';
import { QuestionImage } from '../QuestionImage';
type QuestionHeaderProps = {
  children: ReactNode;
  isDisabled?: boolean;
  isRequired?: boolean;
  questionType?: string;
  media?: Media | null;
};
export const QuestionHeader = t0 => {
  const $ = _c(14);
  const {
    children,
    isDisabled,
    isRequired,
    media
  } = t0;
  const {
    t
  } = useTranslation();
  const t1 = isDisabled && "opacity-50";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeTailwindClasses("flex w-full items-center gap-3 opacity-80", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== media) {
    t4 = media && <QuestionImage media={media} />;
    $[5] = media;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isRequired || $[8] !== t) {
    t5 = isRequired && <p className="flex items-center gap-2"><span className="bg-primary size-2 rounded-full" />{t("required", {
        ns: "common"
      })}</p>;
    $[7] = isRequired;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex items-center justify-between p-4">{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};